module.exports = __webpack_public_path__ + "static/media/bannerGoldBackground.765e183f.png";